import type { ISaveAdapter, PlatformKey } from "../types";

/**
 * Fallback adapter. Session-only. Used when storage is denied (private-window quirks).
 */
export class MemoryAdapter implements ISaveAdapter {
  readonly platform: PlatformKey = "memory";
  private store = new Map<string, string>();

  async read(key: string): Promise<string | null> {
    return this.store.get(key) ?? null;
  }

  async write(key: string, value: string): Promise<void> {
    this.store.set(key, value);
  }

  async clear(key: string): Promise<void> {
    this.store.delete(key);
  }
}
